import {useEffect, useState} from 'react';

import {dispatchCommentReactionsFetchEvent} from '../../../website-ui/helpers/reactions';
import {readReactions} from '../../../website-ui/use-cases/reactions/read-common-reactions';
import {readUserReactions} from '../../../website-ui/use-cases/reactions/read-user-reactions.js';

export const useReadReactions = ({
  articleId,
  user,
  shouldReactionsFetch
}) => {
  const [isFetched, setIsFetched] = useState(false);

  useEffect(
    () => {
      if (shouldReactionsFetch && !isFetched) {
        setIsFetched(true);
        readReactions(articleId).then(() => {
          if (user.isAuthenticated) {
            readUserReactions(articleId).then(dispatchCommentReactionsFetchEvent);
          }
        });
      }
    }, [shouldReactionsFetch, user, articleId, isFetched]
  );
};
